import { render } from "./FamilyCreate.vue?vue&type=template&id=7bdb8135&scoped=true&ts=true"
import script from "./FamilyCreate.vue?vue&type=script&lang=ts"
export * from "./FamilyCreate.vue?vue&type=script&lang=ts"

import "./FamilyCreate.vue?vue&type=style&index=0&id=7bdb8135&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdb8135"]])

export default __exports__